import { sendWebsocketMessage } from '../../../../../../App';
/**
 * get all the soft orders for a particular trade plan
 * @param {number} tradePlanId
 */
export function requestSoftOrdersPerTradePlan(tradePlanId) {
    const msg={
        messageType: "requestSoftOrders",
        tradePlanId: tradePlanId
    }

    sendWebsocketMessage(msg);
}
